import { ApplicationConstants } from '../../shared/applicationConstants';
import { SharedService } from '../../shared/services/sharedService';

export class OblidatService {

    static httpPostRemember(email, lang) {
        return SharedService.httpPost(ApplicationConstants.postRememberUrl, { email: email, lang: lang }).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    throw "Error";
                }
                else {
                   return response.body;
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/oblidat/services/oblidatService.js